/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import { connect } from 'react-redux';
// actions
import { setUniqueEmailCollectionProperty, uploadEmailCollectionBackgroundImage, setCustomEmailCollectionPreviewImage } from 'state/actions/embedsState/embedManagementState/content_status';
// component
import EmailCollectionProperties from 'pages/dashboard/embeds/management/addons/addontypes/emailcollection/emailcollectionproperties/emailcollectionproperties';



/* ========== ~~~~~~~~~~ EMBED PROPERTIES : CONTAINER ~~~~~~~~~~ ========== */
// map state
const mapStateToProps = ({ embedsState, sessionStatus }) => ({
    accountUUID: sessionStatus.accountUUID,
    mocked: sessionStatus.mocked,
    publisherName: embedsState.embedManagementState.contentStatus.addons.userDataCollection.publisherName,
    publisherPrivacyPolicyURL: embedsState.embedManagementState.contentStatus.addons.userDataCollection.publisherPrivacyPolicyURL,
    backgroundColor: embedsState.embedManagementState.contentStatus.addons.userDataCollection.backgroundColor,
    settingCustomEmailCollectionImage: embedsState.embedManagementState.contentStatus.settingCustomEmailCollectionImage,
    location: embedsState.embedManagementState.selectedEmbedStatus.selectedEmbedData.location
});

// map actions
const mapDispatchToProps = dispatch => ({
    setUniqueEmailCollectionProperty: (property, value) => dispatch(setUniqueEmailCollectionProperty(property, value)),
    uploadEmailCollectionBackgroundImage: (accountUUID, imageFile) => dispatch(uploadEmailCollectionBackgroundImage(accountUUID, imageFile)),
    setCustomEmailCollectionPreviewImage: (imageURL) => dispatch(setCustomEmailCollectionPreviewImage(imageURL))
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(EmailCollectionProperties);
